module.exports = __webpack_public_path__ + "img/43_57.a652b456.png";